module.exports = __webpack_public_path__ + "img/ali_app.4503cabe.svg";